export const links = [
  { name: "Home", id: "home" },
  { name: "Features", id: "features" },
  { name: "About Us ", id: "about" },
  { name: "Testimonials", id: "testimonials" },
  { name: "Contact", id: "contact" },
];
